import { SectionHeader } from "@/components/workflow/ui";
import { PediatricHistoryFields } from "@/components/workflow/parts";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Stethoscope, ArrowRight } from "lucide-react";

export default function StepSymptoms({ patient, updPatient, isPediatric, onSubmit }) {
  return (
    <form onSubmit={onSubmit} data-testid="symptom-form">
      <SectionHeader icon={Stethoscope} sub="Step 1 · Patient" title="Symptom intake" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="space-y-1.5">
          <Label>Name</Label>
          <Input data-testid="patient-name" value={patient.name} onChange={updPatient("name")} placeholder="Full name" />
        </div>
        <div className="space-y-1.5">
          <Label>Age (years) *</Label>
          <Input required data-testid="patient-age" value={patient.age} onChange={updPatient("age")} placeholder="≥ 5 (e.g. 54)" />
        </div>
        <div className="space-y-1.5">
          <Label>Sex</Label>
          <Input data-testid="patient-sex" value={patient.sex} onChange={updPatient("sex")} placeholder="M / F" />
        </div>
      </div>
      <div className="mt-4 space-y-1.5">
        <Label>Chief complaint *</Label>
        <Input required data-testid="patient-complaint" value={patient.chief_complaint} onChange={updPatient("chief_complaint")} placeholder="e.g. Chest pain for 2 days" />
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Symptoms (detailed) *</Label>
          <Textarea required rows={4} data-testid="patient-symptoms" value={patient.symptoms} onChange={updPatient("symptoms")} placeholder="Describe all symptoms, their nature and severity…" />
        </div>
        <div className="space-y-1.5">
          <Label>Past / relevant history</Label>
          <Textarea rows={4} data-testid="patient-history" value={patient.past_history} onChange={updPatient("past_history")} placeholder="Comorbidities, medications, allergies, family history…" />
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Duration</Label>
          <Input data-testid="patient-duration" value={patient.duration} onChange={updPatient("duration")} placeholder="e.g. 3 days" />
        </div>
        <div className="space-y-1.5">
          <Label>Weight (kg){isPediatric ? " *" : ""}</Label>
          <Input data-testid="patient-weight" inputMode="decimal" value={patient.weight} onChange={updPatient("weight")} placeholder={isPediatric ? "Needed for weight-based dosing" : "Optional"} />
        </div>
      </div>

      {isPediatric && <PediatricHistoryFields patient={patient} updPatient={updPatient} />}

      <div className="mt-8">
        <Button type="submit" data-testid="submit-symptoms-btn" className="bg-[#002FA7] hover:bg-[#002687] text-white h-11 px-7">
          Get follow-up questions <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </form>
  );
}
